import React from 'react'
import moment from 'moment'
import {ImageBuffer} from '../..'
import { users } from '../../../assets'

import './viewUserPost.css'

const ViewUserPost = ({details}: any) => {
    
  return (
    <>
      <div className='view-post-body-wrapper'>
        <div className='view-post-body-head'>
          <h3>Post information</h3>
        </div>
        <div className="view-post-body-details-wrapper">
          <div className='view-post-details-title'>
            Image:
          </div>
          <div className='view-post-details-main'>
            <div className='view-post-details-image'>
              <ImageBuffer src={`${process.env.REACT_APP_BACKEND_POSTS_IMAGE_URL}${details?.selectedFile}` || users} alt='order image' />
            </div>
          </div>
        </div>
        <div className='view-post-body-details-wrapper'>
          <div className='view-post-details-title'>
            Title:
          </div>
          <div className='view-post-details-main'>
            {details?.title}
          </div>
        </div>

        <div className='view-post-body-details-wrapper'>
          <div className='view-post-details-title'>
            Category:
          </div>
          <div className='view-post-details-main'>
            {details?.category}
          </div>
        </div>

        <div className='view-post-body-details-wrapper'>
          <div className='view-post-details-title'>
            Description:
          </div>
          <div className='view-post-details-main'>
            {details?.description}
          </div>
        </div>
        
        <div className='view-post-body-details-wrapper'>
          <div className='view-post-details-title'>
            Link:
          </div>
          <div className='view-post-details-main'>
            {details?.link}
          </div>
        </div>

        <div className='view-post-body-details-wrapper'>
          <div className='view-post-details-title'>
            created:
          </div>
          <div className='view-post-details-main'>
            {moment(details?.createdAt).format('YYYY-MM-DD H:s:m')} 
          </div>
        </div>

        <div className='view-post-body-details-wrapper'>
          <div className='view-post-details-title'>
            updated:
          </div>
          <div className='view-post-details-main'>
            {moment(details?.updatedAt).format('YYYY-MM-DD H:s:m')} 
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewUserPost